import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import CategoryGrid from "./components/CategoryGrid";
import ContentSections from "./components/ContentSections";
import Footer from "./components/Footer";

const jsonLdHome = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "Best Itaobuy Sheet Platform & Comparison Hub 2026",
  "description": "Discover the most trusted itaobuy sheet systems, compare features, and find the best itaobuy spreadsheet solution. Updated daily with independent analysis, verified rankings, and complete comparison guides.",
  "url": "https://itaobuy.team/",
  "dateModified": "2026-06-28",
  "about": {
    "@type": "Organization",
    "name": "itaobuy.team",
    "url": "https://itaobuy.team/",
    "logo": "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/62f99c0415358bd5388d5ed1df9ac1ff.jpeg",
    "description": "Independent itaobuy sheet comparison hub providing verified spreadsheet rankings, data-driven comparisons, and comprehensive shopping guides for smarter purchasing decisions.",
    "sameAs": ["https://kaspreadsheet.com"]
  },
  "mainEntity": {
    "@type": "Organization",
    "name": "itaobuy.team",
    "url": "https://itaobuy.team/",
    "logo": "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/62f99c0415358bd5388d5ed1df9ac1ff.jpeg"
  }
};

export default function Home() {
  return (
    <main>
      <title>Best Itaobuy Sheet Platform &amp; Comparison Hub 2026 | itaobuy.team</title>
      <meta name="description" content="Discover the most trusted itaobuy sheet systems, compare features, and find the best itaobuy spreadsheet solution. Updated daily with independent analysis, verified rankings, and complete comparison guides." />
      <meta name="keywords" content="itaobuy sheet, itaobuy spreadsheet, itaobuy comparison, best itaobuy sheet, itaobuy sheet guide" />
      <link rel="canonical" href="https://itaobuy.team/" />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLdHome) }} />
      <Navbar />
      <HeroSection />
      <CategoryGrid />
      <ContentSections />
      <Footer />
    </main>
  );
}